module.exports = __webpack_public_path__ + "media/images/area/feature/shikoku/related/id/1-13a0fd8c3cecd4b0644fdb5a13e99ea2.jpg";